export const removeAdditionalRoutes = (mapInstance, count) => {
  const total = parseInt(count?.response, 10);
  if (!mapInstance || isNaN(total)) {
    return;
  }

  for (let i = 0; i <= total; i++) {
    const layerId = `additional-route-layer-${i}`;
    const sourceId = `additional-route-${i}`;

    if (mapInstance.getLayer(layerId)) {
      mapInstance.removeLayer(layerId);
    }

    if (mapInstance.getSource(sourceId)) {
      mapInstance.removeSource(sourceId);
    }
  }
};
